import React from 'react';
import LogoSVG from '../../assets/icons/logo.svg';

interface HeaderProps {
  userName?: string;
  /** District, shown next to the name so the coordinator sees which one she acts for. */
  subClinic?: string | null;
  onLogout?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ userName, subClinic, onLogout }) => {
  return (
    <header
      style={{
        height: 60,
        backgroundColor: '#EBF5F5',
        borderBottom: '1px solid #B4D9D4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        boxSizing: 'border-box',
        zIndex: 1100,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <img src={LogoSVG} alt="Taliaz" style={{ height: 32, width: 'auto' }} />
        <span style={{ fontSize: 16, fontWeight: 600, color: '#284C58' }}>פורטל הקופות</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {userName && (
          <span style={{ fontSize: 14, color: '#374151', fontWeight: 500 }}>
            {userName}
            {subClinic && (
              <span style={{ color: '#6B7280', fontWeight: 400 }}>{` \u00B7 \u05DE\u05D7\u05D5\u05D6 ${subClinic}`}</span>
            )}
          </span>
        )}
        {onLogout && (
          <button
            onClick={onLogout}
            style={{
              background: 'none',
              border: '1px solid #B4D9D4',
              borderRadius: 6,
              padding: '6px 14px',
              fontSize: 14,
              color: '#284C58',
              cursor: 'pointer',
            }}
          >
            התנתקות
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
